<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="../../../assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-03</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PERNYATAAN<br />
                DUKUNGAN PIMPINAN PERUSAHAAN
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini untuk memberi dukungan resmi manajemen pada
                penunjukan PJO perusahaan jasa/ mitra kerja di PT Borneo
                Indobara
              </p>
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor : {{ formValues.nomor }}
                    </p>
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="mb-2 fs-8">Saya yang bertanda tangan di bawah ini:</p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama</label
                    >
                    <p class="fs-8">
                      {{ formValues.nama }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <p class="fs-8">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan</label
                    >
                    <p class="fs-8">
                      {{ formValues.jabatanPimpinan }}
                    </p>
                  </div>
                </div>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  Menyatakan dukungan penuh kepada:
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama</label
                    >
                    <p class="fs-8">
                      {{ formValues.namaPjo }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan</label
                    >
                    <p class="fs-8">
                      {{ formValues.jabatan }}
                    </p>
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Untuk menjalankan program kegiatan sebagai Penanggung Jawab
                  Operasional (PJO) di
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <p class="fs-8">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  sesuai dengan peraturan dan ketentuan yang berlaku.
                </p>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Dan Penanggung Jawab Operasional (PJO) mempunyai wewenang
                  penuh dalam pengelolaan Keselamatan Pertambangan dan
                  Lingkungan Hidup (KPLH) sesuai Kebijakan PT Borneo Indobara,
                  termasuk sumber daya manusia maupun biaya yang dibutuhkan.<br /><br />
                  Demikian Surat Pernyataan ini untuk digunakan sebagaimana
                  mestinya.
                </p>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat</label
                    >
                    <p class="fs-8">
                      {{ formValues.tempat }}
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal</label
                    >
                    <p class="fs-8">
                      {{ formValues.tanggal }}
                    </p>
                  </div>
                </div>

                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Yang Membuat Pernyataan,
                </p>

                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                    </label>
                    <div v-if="fileTtd != ''" class="fs-8">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                    <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                            :disabled="state.disabled" class="example border"></Vue3Signature> -->
                  </div>
                </div>

                <div class="row mb-lg-2">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap</label
                    >
                    <p class="fs-8">
                      {{ formValues.namaTTD }}
                    </p>
                    <label class="form-label fs-8 fw-bold"
                      >Pimpinan Tertinggi Perusahaan</label
                    >
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Catatan:<br />
                  Apabila terjadi perubahan terhadap pimpinan tertinggi dalam
                  struktur organisasi, maka pimpinan tertinggi dalam organisasi
                  wajib menyampaikan Surat Dukungan ulang paling lama 7 hari
                  setelah ada pergantian.<br />
                  Pimpinan tertinggi yang baru wajib menyampaikan komitmennya
                  kepada PT Borneo Indobara dalam bentuk presentasi.
                </p>

                <div class="row">
                  <div class="col-md-6">
                    <label for="fileDokumen" class="form-label fs-8 fw-bold"
                      >File Dokumen (.pdf)</label
                    >
                    <div v-if="fileAttachment != ''" class="fs-8 fw-bolder">
                      File saat ini :
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(fileAttachment)"
                        >Surat Pernyataan Dukungan Pimpinan Perusahaan.pdf</a
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../../GlobalDataMixin";
import {
  API_BASE_URL,
  CMS_DOWNLOAD,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SIO_GET_DUKUNGAN_PIMPINAN,
  CMS_VIEW_IMAGE,
  CMS_GET_KELENGKAPAN_SIO,
} from "@/constants";
import axios from "axios";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url_get_dukungan = API_BASE_URL + CMS_SIO_GET_DUKUNGAN_PIMPINAN;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

export default {
  mixins: [GlobalDataMixin],
  name: "Form5View",
  components: { DefaultLayout },
  data() {
    return {
      sioID: null,
      isLoading: true,
      refIDForm: 5,
      idForm: null,
      formValues: {
        nomor: "",
        nama: "",
        jabatanPimpinan: "",
        namaPjo: "",
        jabatan: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
      },
      url_icon: "",
      fileTtd: "",
      fileAttachment: "",
      validasiFile: {
        typeTtd: false,
        sizeTtd: false,
        typeAtt: false,
        sizeAtt: false,
      },
      kontraktorID: null,
      statusSio: 0,
      kontraktor: [],
    };
  },
  mounted() {
    this.idForm = this.$route.params.id;
    this.getDukungan(this.idForm);
    this.kontraktorid = this.$route.params.kontraktorid;
    this.getKontraktor(this.kontraktorid);
  },
  methods: {
    getDukungan(idform) {
      axios
        .get(url_get_dukungan + idform, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getPJOPengesahan", response);
          let dt = response.data.data;

          if (dt != null) {
            this.sioID = dt.idSio;
            this.formValues.nomor = dt.nomorSurat;
            // this.formValues.nama = dt.namaPimpinan;
            // this.formValues.jabatanPimpinan = dt.jabatanPimpinan;
            // this.formValues.namaPjo = dt.namaPjo;
            // this.formValues.jabatan = dt.jabatanPjo;
            this.formValues.tempat = dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null) {
            //   this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }
            if (dt.attachmentFile != "" && dt.attachmentFile != null) {
              this.fileAttachment = dt.attachmentFile;
            }
            // this.formValues.namaTTD = dt.namaPengesah;
            this.$nextTick(function () {
              this.getKelengkapan(this.sioID);
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);

          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          if (this.formValues.nama == null || this.formValues.nama == "") {
            this.formValues.nama =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }
          if (
            this.formValues.jabatanPimpinan == null ||
            this.formValues.jabatanPimpinan == ""
          ) {
            this.formValues.jabatanPimpinan =
              ret_kel.jabatanAtasan == null ? "" : ret_kel.jabatanAtasan;
          }
          if (
            this.formValues.namaPjo == null ||
            this.formValues.namaPjo == ""
          ) {
            this.formValues.namaPjo =
              ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          }
          if (
            this.formValues.jabatan == null ||
            this.formValues.jabatan == ""
          ) {
            this.formValues.jabatan =
              ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          }
          if (
            this.formValues.namaTTD == null ||
            this.formValues.namaTTD == ""
          ) {
            this.formValues.namaTTD =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }

          if (this.fileTtd == null || this.fileTtd == "") {
            if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan != null) {
              this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>
